import React, { useState, useEffect, useRef } from "react";
import SubmitButton from "../Common/buttons/SubmitButton";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form, Spinner } from "react-bootstrap";
import { ApiHook } from "../../hooks/apiHook";
import { TreeSearchService } from "../../services/tree/network";

const WebTreeNavbar = ({ menu, searchUsername, setSearchUsername }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const [username, setUsername] = useState("");
  const [selectedMenu, setSelectedMenu] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  if (location.pathname === "/sponsor-tree-web") {
    ApiHook.CallSponsorTreeList("", "", searchUsername);
  } else if (location.pathname === "/genealogy-tree-web") {
    ApiHook.CallGenealogyTreeList("", "", searchUsername);
  } else {
    //  Do nothing
  }
  const trimmedPathname = pathname.replace(/^\//, "");

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Debounced search function
  const performSearch = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 1) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }

    setIsSearching(true);
    try {
      const response = await TreeSearchService.searchUsers(searchTerm);
      if (response?.status && response?.data) {
        setSearchResults(response.data);
        setShowDropdown(response.data.length > 0);
      } else {
        setSearchResults([]);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
      setShowDropdown(false);
    } finally {
      setIsSearching(false);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setUsername(value);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Debounce search - wait 300ms after user stops typing
    searchTimeoutRef.current = setTimeout(() => {
      performSearch(value);
    }, 300);
  };

  const handleSelectUser = (user) => {
    setUsername(user.username);
    setSearchResults([]);
    setShowDropdown(false);
    setSearchUsername(user.username);
  };

  const handleSearch = () => {
    setShowDropdown(false);
    setSearchUsername(username);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setShowDropdown(false);
      handleSearch();
    }
  };

  const highlightMatch = (text, query) => {
    if (!query || !text) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? <strong key={index}>{part}</strong> : part
    );
  };

  return (
    <>
      <div
        className={`tree_view_top_filter_bar mt-2 hide_show_mobile ${
          selectedMenu ? "show_mn" : ""
        } ${location.pathname === "/tree-view-web" ? "tree_web_view" : ""}`}
      >
        <div className="row justify-content-between">
          {(trimmedPathname === "genealogy-tree-web" ||
            trimmedPathname === "sponsor-tree-web") && (
            <div className="col-md-4 mob_filter_right ">
              {location.pathname !== "/tree-view-web" &&  
              
              <div className="right_search_div d-flex gap-1 nav-bar-flex" ref={dropdownRef}>
                <div className="position-relative" style={{ flex: 1 }}>
                  <Form.Group>
                    <Form.Control
                      id="Search"
                      type="text"
                      placeholder={t("searchByNameOrUsername")}
                      onChange={(e) => handleChange(e)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={() => searchResults.length > 0 && setShowDropdown(true)}
                      value={username}
                      autoComplete="off"
                    />
                    {isSearching && (
                      <Spinner
                        animation="border"
                        size="sm"
                        className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                      />
                    )}
                  </Form.Group>
                  
                  {/* Search Results Dropdown */}
                  {showDropdown && searchResults.length > 0 && (
                    <div 
                      className="search-dropdown-menu"
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        backgroundColor: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        zIndex: 1000,
                        maxHeight: '300px',
                        overflowY: 'auto',
                      }}
                    >
                      {searchResults.map((user) => (
                        <div
                          key={user.id}
                          className="search-result-item"
                          onClick={() => handleSelectUser(user)}
                          style={{
                            padding: '10px 15px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #eee',
                            transition: 'background-color 0.2s',
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                        >
                          <div style={{ fontWeight: 'bold', color: '#333' }}>
                            {highlightMatch(user.username, username)}
                          </div>
                          {user.fullName && (
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              {highlightMatch(user.fullName, username)}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <SubmitButton
                  className="btn btn-primary"
                  text="search"
                  click={handleSearch}
                />
              </div>
              }
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default WebTreeNavbar;
